// theirs
import React, { useState, useEffect, useRef } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import styled from 'styled-components'
// ours
import GlobalStyle from './styles/global'
import Landscape from './components/Landscape'
import Canvas from './components/Canvas'
import NavAside from './components/NavAside'

const StyledApp = styled.div`
    padding: 0;
    margin: 0;
    position: fixed;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    overflow: hidden scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    &::-webkit-scrollbar {
        width: 0;
        scroll-padding-right: 0;
    }

`
export interface CollectionContextInterface {
    isPhone: boolean
    isTablet: boolean
    isDesktop: boolean
    isLandscape: boolean
    dimensions: {
        height: number
        width: number
    }
    isScrolledToBottom: boolean
}

export const CollectionContext =
    React.createContext<CollectionContextInterface | null>(null)

const App = () => {
    const isBrowser = () => typeof window !== 'undefined'
    const scrollerRef = useRef() as React.MutableRefObject<HTMLInputElement>;

    const [dimensions, setDimensions] = useState({
        height: isBrowser() ? window.innerHeight : 0,
        width: isBrowser() ? window.innerWidth : 0,
    })

    const [isScrolledToBottom, setIsScrolledToBottom] = useState(false)

    const debouncedHandleResize = useDebouncedCallback(() => {
        setDimensions({
            height: isBrowser() ? window.innerHeight : 0,
            width: isBrowser() ? window.innerWidth : 0,
        })
    }, 100)

    const debouncedHandleScroll = useDebouncedCallback(() => {
        let isAppAtTheBottom = true
        if (scrollerRef && scrollerRef.current){
            isAppAtTheBottom = 
            Math.ceil(window.innerHeight + scrollerRef.current.scrollTop) >= 
            scrollerRef.current.scrollHeight - (window.innerHeight*0.5)

            console.log("inside wp: ", Math.ceil((window.innerHeight + scrollerRef.current.scrollTop)*100/scrollerRef.current.scrollHeight)+"% scroll" )

        }
        setIsScrolledToBottom(isAppAtTheBottom)

    }, 0)

    useEffect(() => {
        window.addEventListener('resize', debouncedHandleResize)
        
        if (scrollerRef && scrollerRef.current){
            let sr = scrollerRef.current
            sr.addEventListener('scroll', debouncedHandleScroll, {
                passive: true,
            })
            return function cleanupListener() {
                window.removeEventListener('resize', debouncedHandleResize)
                sr.removeEventListener('scroll', debouncedHandleScroll)
            }
        }
    }, [debouncedHandleResize, debouncedHandleScroll])

    const isPhone = dimensions.width < 768
    const isTablet = dimensions.width >= 768 && dimensions.width < 1024
    const isDesktop = dimensions.width >= 1024
    const isLandscape = dimensions.height < dimensions.width


    const collectionContext: CollectionContextInterface = {
        isPhone: isPhone,
        isTablet: isTablet,
        isDesktop: isDesktop,
        isLandscape: isLandscape,
        dimensions: dimensions,
        isScrolledToBottom: isScrolledToBottom,
    }

    const appVersion = `${process.env.REACT_APP_NAME}-${process.env.REACT_APP_VERSION}`

    return (
        <CollectionContext.Provider value={collectionContext}>
            <StyledApp className={`scrollable ${appVersion}`} ref={scrollerRef}>
                <GlobalStyle />
                {isDesktop &&
                    window.location.pathname.indexOf('our-story') === 1 && (
                        <NavAside />
                    )}
                <Landscape />
                <Canvas />
            </StyledApp>
        </CollectionContext.Provider>
    )
}

export default App
